import { getNoHtmlPatternError, noHtmlPatternValidator } from "./rawValidators";
const validateNoHtmlPattern = (value, fieldName) => noHtmlPatternValidator(value) || (typeof fieldName === 'string' ? getNoHtmlPatternError(fieldName) : false);

/** For react-hook-form library. */
export const noHtmlPatternValidation = fieldName => ({
  validate: {
    noHtmlPattern: value => validateNoHtmlPattern(value, fieldName)
  }
});